document.addEventListener("DOMContentLoaded", function () {

  const nextButtons = document.querySelectorAll(".step-next");
  const prevButtons = document.querySelectorAll(".step-prev");
  const progressSteps = document.querySelectorAll(".progress-step");
  const progressFill = document.querySelector(".progress-line-fill");

  /* PROGRESS */

  function updateProgress(stepClass){
    const map = {
      "step-1": 0,
      "step-2": 1,
      "step-3": 2
    };

    const index = map[stepClass];
    if(index === undefined) return;

    progressSteps.forEach((step, i) => {
      step.classList.toggle("active", i <= index);
      step.classList.remove("current");
    });

    if(progressSteps[index]){
      progressSteps[index].classList.add("current");
    }

    if(progressFill){
      const percent = (index / (progressSteps.length - 1)) * 100;
      progressFill.style.width = percent + "%";
    }
  }

  /* STEP NAVIGATION */

  function goToStep(currentStep, targetStep) {

    if(currentStep){
      currentStep.classList.remove("active");
    }

    if(targetStep){
      targetStep.classList.add("active");

      const stepClass = Array.from(targetStep.classList)
        .find(c => /^step-\d+$/.test(c));

      updateProgress(stepClass);

      window.scrollTo({
        top:0,
        behavior:"smooth"
      });
    }
  }

  nextButtons.forEach(button => {
    button.addEventListener("click", function(){

      const currentStep = this.closest(".form-step");

      if(!validateStep(currentStep)){
        return;
      }

      const nextStep = document.querySelector("." + this.dataset.next);
      goToStep(currentStep, nextStep);

    });
  });

  prevButtons.forEach(button => {
    button.addEventListener("click", function(){

      const currentStep = this.closest(".form-step");
      const prevStep = document.querySelector("." + this.dataset.prev);

      goToStep(currentStep, prevStep);

    });
  });

  updateProgress("step-1");


  /* VALIDATION */

  function validateStep(step){

    const fields = step.querySelectorAll("input, select, textarea");
    let valid = true;

    fields.forEach(field => {

      if(!field.checkValidity()){

        field.closest(".field")?.classList.add("has--error");
        field.classList.add("has--error");

        field.reportValidity();
        valid = false;

      } else {

        field.closest(".field")?.classList.remove("has--error");
        field.classList.remove("has--error");

      }

    });

    return valid;
  }


  /* SUBMIT LOADING */

  const form = document.querySelector(".job-application-form form");
  const submitButton = document.querySelector(".submit-application");

  if(form && submitButton){

    form.addEventListener("submit", function(){

      submitButton.disabled = true;
      submitButton.classList.add("is-loading");
      submitButton.innerText = "Sending...";

    });

  }


  /* SUCCESS STATE */

  if(window.location.search.includes("contact_posted=true")){

    const form = document.querySelector(".job-application-form form");
    const steps = document.querySelectorAll(".progress-step");
    const fill = document.querySelector(".progress-line-fill");

    if(fill){
      fill.style.width = "100%";
    }

    if(steps.length){

      steps.forEach(step=>{
        step.classList.add("active");
        step.classList.remove("current");
        step.classList.remove("is-complete");
      });

      const lastStep = steps[steps.length - 1];
      lastStep.classList.add("current");
      lastStep.classList.add("is-complete");
    }

    if(form){

      form.innerHTML = `
        <div class="form-success">
          <h2>Application Sent</h2>
          <p>Thank you for applying. Our team will review your application and contact you soon.</p>

          <a href="/" class="button custom--typ">
            Back to Home
          </a>
        </div>
      `;

      window.scrollTo({
        top:0,
        behavior:"smooth"
      });
    }

  }


  /* ADD SECOND COMPANY */

  const addCompanyBtn = document.getElementById("add-company");
  const extraCompany = document.getElementById("extra-company");

  if(addCompanyBtn && extraCompany){

    addCompanyBtn.addEventListener("click", function(){

      extraCompany.classList.add("show");
      addCompanyBtn.style.display = "none";

    });

  }


  const phoneInput = document.getElementById("phone");

if(phoneInput){

  phoneInput.addEventListener("input", function(){

    let numbers = this.value.replace(/\D/g,"").substring(0,10);

    let formatted = numbers;

    if(numbers.length > 6){
      formatted = "(" + numbers.substring(0,3) + ") " +
                  numbers.substring(3,6) + "-" +
                  numbers.substring(6,10);
    }
    else if(numbers.length > 3){
      formatted = "(" + numbers.substring(0,3) + ") " +
                  numbers.substring(3);
    }
    else if(numbers.length > 0){
      formatted = "(" + numbers;
    }

    this.value = formatted;

  });

}

const zipInput = document.querySelector('input[name="contact[zip]"]');

if(zipInput){

  zipInput.addEventListener("input", function(){

    this.value = this.value.replace(/\D/g, "").substring(0,5);

  });

}

});